import React from 'react';

import ComparisonTable from 'common/Table/ComparisonTable';
import { CmiDigestWatchlistRateComparison, CmiDigestWatchlistRateComparisonRow } from 'types/cmiDigestWatchlist';

type Props = {
  careTypes: CmiDigestWatchlistRateComparison[];
};

const CommunitiesToWatchRateComparisonTable = ({ careTypes }: Props) => (
  <ComparisonTable<CmiDigestWatchlistRateComparisonRow, CmiDigestWatchlistRateComparison>
    careTypes={careTypes}
    getValueColumns={(careType) =>
      careType.room_types.map((roomType) => ({
        key: `room-type-${roomType}`,
        title: roomType,
        getValue: (row) => row.rates[roomType] ?? null,
      }))
    }
  />
);

export default CommunitiesToWatchRateComparisonTable;
